export default __webpack_public_path__ + "cardModelNlp-skillc4dfe4.png";